<template>
    <div class="info">
        <div class="title" v-if="layerOption != CONSTANTS.GEOJSON_TYPE.REAL_WATER">
            {{ infoTitle }}
        </div>
        <div :style="`width: ${isMobile ? '250px' : '800px'}; margin: auto; text-align: center`">
            <span v-for="(item, index) in listLegend" :key="index">
                <span
                    class="color-pan"
                    :style="`background:#${item.color}; width: ${isMobile ? '20%' : '5%'};`"
                    ><label> {{ item.value }}</label></span
                >
            </span>
        </div>
    </div>
</template>
<script>
import CONSTANTS from '../constants';
import { mapState } from 'vuex';
export default {
    data() {
        return {
            CONSTANTS
        };
    },
    computed: {
        ...mapState({
            layerOption: (state) => state.geojson.layerOption,
            isMobile: (state) => state.page.isMobile
        }),
        infoTitle() {
            return this.layerOption == CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN ||
                this.layerOption == CONSTANTS.GEOJSON_TYPE.FORECAST_RAIN ||
                this.layerOption == CONSTANTS.GEOJSON_TYPE.REAL_RAIN
                ? 'Lượng mưa (mm/h)'
                : 'Mực nước (m)';
        },
        listLegend() {
            return this.layerOption == CONSTANTS.GEOJSON_TYPE.CURRENT_THUNDER ||
                this.layerOption == CONSTANTS.GEOJSON_TYPE.SCRIPT_FLOOD
                ? CONSTANTS.THUNDER_LEGEND_INFO
                : this.layerOption == CONSTANTS.GEOJSON_TYPE.REAL_WATER
                ? CONSTANTS.WATER_LEGEND_INFO
                : CONSTANTS.RAIN_LEGEND_INFO;
        }
    }
};
</script>
<style lang="scss">
.info {
    padding: 6px 8px;
    font: 14px/16px Arial, Helvetica, sans-serif;

    .title {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 5px;
        text-align: center;
    }
    .color-pan {
        display: inline-block;
        height: 15px;
        text-align: center;
        font-size: 12px;
        label {
            color: white;
        }
    }
}
</style>